import React from 'react'
import { Col, Container, Nav, Row } from 'react-bootstrap'

import navIcon1 from "../../assets/images/nav-icon1.svg";
import gitLogo from "../../assets/images/gitLinkVector.svg";

import "./Footer.scss"
const Footer = () => {
  return (
    <footer className='footer flex-shrink-0 py-3 bg-dark text-white-50' id="sticky-footer">
        <Container>
            <Row className='align-item-center'>
                <Col sm={3}>
                    <Nav.Link href="mailto:dorota.bialy95@gmail.com" className="footer__link">Email me</Nav.Link>
                </Col>
                <Col sm={9} className="text-center text-sm-end">
                    <div className='social-icon footer__social-icons'>
                        <Nav.Link className="nav__link" href="https://www.linkedin.com/in/dorota-b-304064229/" target="_blank" rel="noreferrer">
                            <img src={navIcon1} alt="Linked In" className="footer-img"/>
                        </Nav.Link>
                        <Nav.Link className="nav__link"  href="https://github.com/DorBia" target="_blank" rel="noreferrer">
                            <img src={gitLogo} alt="Github" />
                        </Nav.Link>
                    </div>
                </Col>
            </Row>
        </Container>
    </footer>
  )
}

export default Footer